import { SetStateAction } from 'react';
import { Query } from '@apollo/client/react/components';
import { ALL_GRADES, ALL_INTERVENTIONS, ALL_SP_PROGRAMMES, FILTERED_SUBJECTS } from '../../graphql';
import { formatSelectValue } from '../../utils';
import { Flex, StyledDatePicker, StyledFormSelect } from '../shared';
import { OperationVariables, QueryResult } from '@apollo/client';

type Props = {
  programmeIds?: string[];
  gradeIds?: string[];
  setSubjects: SetStateAction<any>;
  setInterventions: SetStateAction<any>;
  setGrades: SetStateAction<any>;
  setProgrammes: SetStateAction<any>;
  setStartDate: SetStateAction<any>;
  setEndDate: SetStateAction<any>;
};

const DashboardFilters = ({
  programmeIds,
  gradeIds,
  setSubjects,
  setInterventions,
  setGrades,
  setProgrammes,
  setEndDate,
  setStartDate,
}: Props) => {
  return (
    <Flex size="1" direction="row">
      <Query query={ALL_SP_PROGRAMMES}>
        {({ loading, error, data }: QueryResult<any, OperationVariables>) => {
          return (
            <Flex size="1" direction="row" marginRight="10px">
              <StyledFormSelect
                isClearable={true}
                name="programmeIds"
                label="Programmes"
                isMulti={true}
                onChange={(options: { value: any }[]) =>
                  setProgrammes(options ? options.map((option: any) => option.value) : undefined)
                }
                options={
                  loading || error
                    ? []
                    : data.programmes.map((item: any) =>
                        formatSelectValue({
                          label: item.name,
                          value: item.id,
                        })
                      )
                }
              />
            </Flex>
          );
        }}
      </Query>
      <Query query={ALL_INTERVENTIONS} variables={{ input: { ...(programmeIds && { programmeIds }) } }}>
        {({ loading, error, data }: QueryResult<any, OperationVariables>) => {
          return (
            <Flex size="1" direction="row" marginRight="10px">
              <StyledFormSelect
                isClearable={true}
                name="interventionIds"
                label="Interventions"
                isMulti={true}
                onChange={(options: { value: any }[]) =>
                  setInterventions(options ? options.map((option: any) => option.value) : undefined)
                }
                options={
                  loading || error
                    ? []
                    : data.allInterventions.map((item: any) =>
                        formatSelectValue({
                          label: item.name,
                          value: item.id,
                        })
                      )
                }
              />
            </Flex>
          );
        }}
      </Query>
      <Query query={ALL_GRADES}>
        {({ loading, error, data }: QueryResult<any, OperationVariables>) => {
          return (
            <Flex size="1" direction="row" marginRight="10px">
              <StyledFormSelect
                isClearable={true}
                isMulti={true}
                name="gradeIds"
                label="Grades"
                onChange={(options: { value: any }[]) =>
                  setGrades(options ? options.map((option: any) => option.value) : undefined)
                }
                options={
                  loading || error
                    ? []
                    : data.grades.map((item: any) =>
                        formatSelectValue({
                          label: item.value,
                          value: item.id,
                        })
                      )
                }
              />
            </Flex>
          );
        }}
      </Query>
      <Query query={FILTERED_SUBJECTS} variables={{ input: { ...(gradeIds && { gradeIds }) } }}>
        {({ loading, error, data }: QueryResult<any, OperationVariables>) => {
          return (
            <Flex size="1" direction="row" marginRight="10px">
              <StyledFormSelect
                isClearable={true}
                name="subjectIds"
                label="Subjects"
                isMulti={true}
                onChange={(options: { value: any }[]) =>
                  setSubjects(options ? options.map((option: any) => option.value) : undefined)
                }
                options={
                  loading || error
                    ? []
                    : data.filteredSubjects.map((item: any) =>
                        formatSelectValue({
                          label: item.subjectGradeReference,
                          value: item.id,
                        })
                      )
                }
              />
            </Flex>
          );
        }}
      </Query>
      <Flex size="1" direction="row" marginTop="-1px">
        <StyledDatePicker
          label="Date"
          name="dashboardDate"
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          fontSize="0.9em"
          maxHeight="10px"
        />
      </Flex>
    </Flex>
  );
};

export default DashboardFilters;
